/* @flow */

import { type PreactAppStore } from './types';
import { saveState } from './local-storage';
import getPersistedState from './get-persisted-state';

const persistState = (store: PreactAppStore) => () => (
    saveState(getPersistedState(store.getState()))
);

export default persistState;
